import FooterNavItem from './FooterNavItem'

export default FooterNavItem
